import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect, useSelector } from 'react-redux';
import { Grid } from '@material-ui/core';
import { useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import { FormInputViewOnly } from 'elements/Inputs/FormInput/FormInputViewOnly';
import { UserInfoSectionData } from './UserInfoSection.data';
import { FormInput } from 'elements/Inputs/FormInput';
import { getLateEntryTrfList } from '../../Forms.actions';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    }
}));

const UserInfoSection = (props) => {
    const { selectedTag, formData, userRole, changeHandler, isFormReadOnly, currentView, formDataSRA, IsLateEntry, isLateEntrySaflocExist, isLateEntrylastFlowDate, isLateEntryTrfAlredySubmited, getLateEntryTrfLists } = props;
    const { instance } = useMsal();
    const userName = instance.getActiveAccount();
    const classes = useStyles();
    const isNonMoFeatureEnabled = useSelector(({ Home }) => Home.isNonMoFeatureEnabled);
    const isP8View = currentView === 'P8-1';
    const handleTagBlur = () => {
        if (IsLateEntry && formData?.F2SapFloc && formData?.F20Mo) {
            getLateEntryTrfLists();
        }
    };
    const filterViewData = UserInfoSectionData(selectedTag, userName, formData, formDataSRA, isNonMoFeatureEnabled, IsLateEntry, handleTagBlur);
    return (
        <Grid container spacing={1} className={classes.root}>
            {
                filterViewData.rows.map(row => (
                    <Grid item container xs={12} key={row.key}>
                        {row.fields.map(field => (
                            <Grid item xs={field.xs} key={field.key}>
                                {!field.readOnly ? (
                                    <FormInput
                                        id={field.key}
                                        name={field.key}
                                        label={field.label}
                                        value={field.value}
                                        type={field.type}
                                        isRequired={field.isRequired}
                                        handleChange={changeHandler}
                                        readOnly={field.readOnly || IsLateEntry ? (isFormReadOnly && !['F2SapFloc', 'F20Mo'].includes(field.key)) : isFormReadOnly || isP8View}
                                        labelWidth={field.labelWidth}
                                        width={field.width}
                                        padding={field.padding}
                                        textAlign={field.textAlign}
                                        userRole={userRole}
                                        isDisabled={field.isDisabled}
                                        height={field.height}
                                        marginTop={field.marginTop}
                                        borderTop={field.borderTop}
                                        borderBottom={field.borderBottom}
                                        marginBottom={field.marginBottom}
                                        maxLength={field.maxLength}
                                        isLateEntrySaflocExist={isLateEntrySaflocExist}
                                        isLateEntrylastFlowDate={isLateEntrylastFlowDate}
                                        isLateEntryTrfAlredySubmited={isLateEntryTrfAlredySubmited}
                                        handleBlur={field.handleBlur}
                                    />
                                ) : (
                                    <FormInputViewOnly
                                        id={field.key}
                                        label={field.label}
                                        value={field.value}
                                        hidden={field.hidden}
                                        labelWidth={field.labelWidth}
                                        width={field.width}
                                        labelTextAlign={field.labelTextAlign}
                                        wordBreak={field.wordBreak}
                                    />
                                )}
                            </Grid>
                        )
                        )}
                    </Grid>
                ))
            }
        </Grid>
    );
};

const mapStateToProps = ({ Forms, Home }) => ({
    selectedTag: Forms.selectedTag,
    originalFormData: Forms.formData,
    userRole: Home.userRole,
    currentView: Home.currentView,
    formDataSRA: Forms.formDataSRA,
    IsLateEntry: Home.IsLateEntry,
    isLateEntrySaflocExist: Forms.isLateEntrySaflocExist,
    isLateEntrylastFlowDate: Forms.isLateEntrylastFlowDate,
    isLateEntryTrfAlredySubmited: Forms.isLateEntryTrfAlredySubmited
});
const mapDispatchToProps = dispatch => ({ dispatch, getLateEntryTrfLists: () => dispatch(getLateEntryTrfList()) });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserInfoSection);

UserInfoSection.propTypes = {
    changeHandler: PropTypes.func,
    currentView: PropTypes.string,
    formData: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    formDataSRA: PropTypes.object,
    getLateEntryTrfLists: PropTypes.func,
    isFormReadOnly: PropTypes.bool,
    IsLateEntry: PropTypes.bool,
    isLateEntrylastFlowDate: PropTypes.bool,
    isLateEntrySaflocExist: PropTypes.bool,
    isLateEntryTrfAlredySubmited: PropTypes.bool,
    selectedTag: PropTypes.object,
    userRole: PropTypes.string,
};
